import {
  ChartBarIcon,
  Cog6ToothIcon,
  HomeIcon,
  ArchiveBoxArrowDownIcon,
  HomeModernIcon,
  ScaleIcon,
  TruckIcon,
  ArrowPathRoundedSquareIcon,
  ChartPieIcon,
  NewspaperIcon,
  WrenchIcon,
  LifebuoyIcon,
  TagIcon,
  ChartBarSquareIcon,
  CogIcon,
} from "@heroicons/react/24/outline";

import { isEmployeeUserType } from "./utility";
import { moduleEnabled } from "./tenantModules";
import { tenantLabel } from "./tenantLabels";
import { ArchiveBoxIcon } from "@heroicons/react/20/solid";

export default function routes(pathname, user_type, tenant = null) {
  var title;
  var routes;

  const isCFIA = user_type === 2;
  const assemblyItemsLabel = tenantLabel(tenant, "assembly_items", "BOM items");
  const manufacturedProductsLabel = tenantLabel(
    tenant,
    "manufactured_products",
    "Manufactured",
  );
  const receivingLabel = tenantLabel(tenant, "receiving", "Purchasing");
  const packagingLabel = tenantLabel(tenant, "packaging", "Packaging");
  const ordersLabel = tenantLabel(tenant, "orders", "Orders");
  const shippingLabel = tenantLabel(tenant, "shipping", "Shipping");
  const customersLabel = tenantLabel(tenant, "customers", "Customers");
  const suppliersLabel = tenantLabel(tenant, "suppliers", "Suppliers");
  const locationsLabel = tenantLabel(tenant, "locations", "Locations");
  const qaReportsLabel = tenantLabel(tenant, "qa_reports", "QA Reports");
  const knowledgeBaseHref =
    tenant?.settings?.links?.knowledgeBase ??
    "https://knowledge.qatrace.com/mrakovic-knowledge-base/";

  routes = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: HomeIcon,
      current: false,
      showInMenu: !isCFIA && moduleEnabled(tenant, "dashboard"),
    },
    {
      name: "Export label",
      href: "/export-label",
      icon: NewspaperIcon,
      current: false,
      showInMenu: isCFIA,
    },
    {
      name: receivingLabel,
      icon: ArchiveBoxArrowDownIcon,
      current: false,
      showInMenu: !isCFIA && moduleEnabled(tenant, "receiving"),
      children: [
        { name: "Purchase Orders", href: "/purchase-orders", current: false },
        {
          name: "Receiving Invoices",
          href: "/receiving-invoices",
          current: false,
        },
        // { name: "Receiving Records", href: "/receiving-index", current: false },
      ],
    },
    {
      name: "Production",
      icon: HomeModernIcon,
      current: false,
      showInMenu:
        !isCFIA && !isEmployeeUserType() && moduleEnabled(tenant, "production"),
      children: [
        {
          name: "New Production",
          href: "/manufacture-product",
          current: false,
        },
        { name: "History", href: "/manufactured-products", current: false },
        { name: "Calendar", href: "/calendar/production", current: false },
      ],
    },
    {
      name: "Production",
      icon: HomeModernIcon,
      current: false,
      showInMenu: isEmployeeUserType() && moduleEnabled(tenant, "production"),
      children: [
        {
          name: "Manufacture New",
          href: "/manufactured-products-employee",
          current: false,
        },
      ],
    },
    {
      name: packagingLabel,
      icon: ScaleIcon,
      current: false,
      showInMenu: !isCFIA && moduleEnabled(tenant, "packaging"),
      children: [
        {
          name: "Package New",
          href: "/packaging-new",
          current: false,
        },
        { name: "History", href: "/packaging-reports", current: false },
      ],
    },
    {
      name: ordersLabel,
      icon: NewspaperIcon,
      current: false,
      showInMenu:
        !isCFIA && !isEmployeeUserType() && moduleEnabled(tenant, "orders"),
      open: false,
      children: [
        { name: "Create", href: "/create-order" },
        { name: "Manage Orders", href: "/orders" },
        { name: "Calendar", href: "/calendar/orders", current: false },
      ],
    },
    {
      name: shippingLabel,
      icon: TruckIcon,
      current: false,
      showInMenu: !isCFIA && moduleEnabled(tenant, "shipping"),
      children: [
        { name: "Shipments", href: "/shippings", current: false },
        { name: "Returns / Credits", href: "/credit-returns", current: false },
      ],
    },
    {
      name: "Inventory",
      icon: ScaleIcon,
      current: false,
      showInMenu:
        !isCFIA && !isEmployeeUserType() && moduleEnabled(tenant, "inventory"),
      children: [
        {
          name: "Raw Material",
          href: "/inventory-raw-material",
          current: false,
        },
        {
          name: manufacturedProductsLabel,
          href: "/inventory-manufactured-material",
          current: false,
        },
        {
          name: "Pallet let down",
          href: "/pallet-let-down",
          current: false,
        },
      ],
    },
    {
      name: "Traceability",
      icon: ArrowPathRoundedSquareIcon,
      current: false,
      showInMenu:
        !isCFIA &&
        !isEmployeeUserType() &&
        moduleEnabled(tenant, "traceability"),
      children: [
        {
          name: "Manufactured",
          href: "/traceability/manufactured",
          current: false,
        },
        { name: "Supplier", href: "/traceability/supplier", current: false },
        {
          name: "Packaging Barcode Lookup",
          href: "/traceability/packaging-barcode",
          current: false,
        },
        {
          name: "Receiving Item Lookup",
          href: "/traceability/receiving-item",
          current: false,
        },
      ],
    },
    {
      name: qaReportsLabel,
      icon: ChartBarIcon,
      current: false,
      showInMenu:
        !isCFIA && !isEmployeeUserType() && moduleEnabled(tenant, "qa"),
      children: [
        {
          name: "Reports",
          href: "/qa-reports",
          current: false,
        },
      ],
    },
    {
      name: "QA Module",
      icon: ChartBarSquareIcon,
      current: false,
      showInMenu:
        !isCFIA && !isEmployeeUserType() && moduleEnabled(tenant, "qa"),
      children: [
        {
          name: "In process monitoring",
          href: "/in-process-monitoring",
          current: false,
        },
        // {
        //   name: "Lab Samples",
        //   href: "/lab-samples",
        //   current: false,
        // },
        // {
        //   name: "Equipment Maintenance",
        //   href: "/equipment-maintenance",
        //   current: false,
        // },
        // {
        //   name: "Visitors Log",
        //   href: "/visitors",
        //   current: false,
        // },
      ],
    },
    {
      name: "Recipes",
      href: "/recipes",
      icon: ChartPieIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
    },
    {
      name: "Products",
      href: "/my-products",
      icon: WrenchIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
    },
    {
      name: "Barcode Extractor",
      href: "/barcode-scanner",
      icon: TagIcon,
      current: false,
      showInMenu: !isCFIA && isEmployeeUserType(),
    },
    {
      name: "Setup",
      icon: Cog6ToothIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      open: false,
      children: [
        {
          name: "Allergens",
          href: "/product-allergens",
          current: false,
        },
        { name: "Barcode Extractor", href: "/barcode-scanner", current: false },
        { name: assemblyItemsLabel, href: "/bom-items", current: false },
        { name: "Brands", href: "/brands", current: false },
        {
          name: "Certification Types",
          href: "/certification-types",
          current: false,
        },
        { name: "Claims", href: "/product-claims", current: false },
        { name: customersLabel, href: "/customers", current: false },
        { name: locationsLabel, href: "/locations", current: false },
        { name: "Media Manager", href: "/media-manager", current: false },
        { name: "Preservatives", href: "/preservatives", current: false },
        { name: "Production Costs", href: "/production-costs", current: false },
        { name: suppliersLabel, href: "/suppliers", current: false },
        { name: "Supplier items", href: "/supplier-items", current: false },
        { name: "Types", href: "/product-types", current: false },
        { name: "Unit of measures", href: "/unit-of-measures", current: false },
        { name: "Quickbooks", href: "/quickbooks-login", current: false },
        { name: "Users", href: "/users", current: false },
      ],
    },
    {
      name: "QA Setup",
      icon: CogIcon,
      current: false,
      showInMenu: !isCFIA && !isEmployeeUserType(),
      open: false,
      children: [
        // { name: "Equipments", href: "/equipments", current: false },
        // { name: "Laboratories", href: "/laboratories", current: false },
        {
          name: "Process Statuses",
          href: "/process-statuses",
          current: false,
        },
        // { name: "Visitor Types", href: "/visitor-types", current: false },
      ],
    },
    {
      name: "Knowledge Base",
      href: knowledgeBaseHref,
      icon: LifebuoyIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Pallet let down",
      href: "/pallet-let-down",
      icon: ArchiveBoxIcon,
      current: false,
      showInMenu: !isCFIA && isEmployeeUserType(),
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
